import React from 'react';
import { ApiError } from '@/lib/errors';

interface Props {
  title?: string;
  error: unknown;
  onRetry?: () => void;
}

export function ErrorState({ title = 'Something went wrong', error, onRetry }: Props) {
  const message =
    error instanceof ApiError
      ? error.problem?.detail ?? error.message
      : error instanceof Error
        ? error.message
        : 'Unknown error';
  return (
    <div className="state state-error">
      <h4>{title}</h4>
      <p className="text-small">{message}</p>
      {onRetry ? (
        <button type="button" className="btn btn-secondary btn-sm mt-3" onClick={onRetry}>
          Retry
        </button>
      ) : null}
    </div>
  );
}
